import { render, staticRenderFns } from "./fix-side-comment-commit.vue?vue&type=template&id=52c74fce&scoped=true"
import script from "./fix-side-comment-commit.vue?vue&type=script&lang=js"
export * from "./fix-side-comment-commit.vue?vue&type=script&lang=js"
import style0 from "./fix-side-comment-commit.vue?vue&type=style&index=0&id=52c74fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c74fce",
  null
  
)

export default component.exports